// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__18w5o","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1TRAe"};